import React from 'react'
import withHeaderItem from 'utils/hoc/withHeaderItem'

const NavToggle = () => {
    return null   // ← removes the hamburger completely
}

export default withHeaderItem(NavToggle)
